import React from 'react'
import  './Empresa.css'

function Empesa() {
    return (
        <div>
empresa            
        </div>
    )
}

export default Empesa
